<template>
  <div class="crpg-m-tokyo-calender-club-specialty doc">
    <div class="catch">{{ contentTitle }}</div>
    <img :src="require(`@/assets/img/${image}`)" alt="" />
    <p class="newline">{{ contentText }}</p>
  </div>
</template>

<script>
export default {
  props: {
    contentTitle: String,
    contentText: String,
    image: String,
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/molecules/tokyoCalenderClub/specialty.scss";
</style>
